module.exports = __webpack_public_path__ + "img/file-font.7849ffa1.svg";